// extracted by mini-css-extract-plugin
export default {"MemberCard":"MemberCard_MemberCard__QikzL","Title":"MemberCard_Title__QvCec","Image":"MemberCard_Image__fILUz"};